import React, { useEffect, useState } from 'react';
import {
  Table,
  Card,
  Row,
  Col,
  Button,
  Badge,
  Form,
  Modal,
  Spinner,
  Toast,
  ToastContainer,
  Alert,
} from 'react-bootstrap';
import { FaPlus, FaEdit, FaTrash, FaExclamationTriangle } from 'react-icons/fa';
import axios from 'axios';
import "../../ComponentsCss/CrossBorderTransfersTab.css";
import { useAuth } from "../../contexts/AuthContext";
import  { logActivity }  from '../../utils/activityLogApi';
const CrossBorderTransfersTab = ({ userData, onScoreUpdate, regulation,logToAccessLogs,      // â† ADD THIS
  showNotification  }) => {
  const getUserRegion = () => {
    return sessionStorage.getItem("userRegion") || "GB";
  };

  // Restricted countries list (negative list - to be updated based on govt notifications)
  const RESTRICTED_COUNTRIES = [
    // Add countries as notified by Central Government
    // Currently no official list published as of Dec 2024
  ];
const { profile } = useAuth();
   const organizationId = profile?.orgId;
  const [transfers, setTransfers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editingTransfer, setEditingTransfer] = useState(null);
  const [form, setForm] = useState({
    type: '',
    source: '',
    destination: '',
    entity: '',
    status: '',
    date: '',
    tiaFile: null,
    // New DPDP-required fields
    countryStatus: '', // Allowed / Restricted
    transferPurpose: '',
    recipientRole: '', // Processor / Sub-processor / Controller
    noticeProvided: false,
    consentObtained: false,
    consentReference: '', // Link to consent record
    noticeReference: '', // Link to privacy notice
    govtNotificationReady: false,
    legalBasis: '', // Consent / Legitimate Use (Section 7)
    standardContractualClauses: false,
    onwardTransferRestrictions: '',
  });
  const [toast, setToast] = useState({ show: false, message: '', variant: '' });
  const [expandedRows, setExpandedRows] = useState(new Set());
  const userId =organizationId;

const toggleRow = (id) => {
  const newExpanded = new Set(expandedRows);
  if (newExpanded.has(id)) {
    newExpanded.delete(id);
  } else {
    newExpanded.add(id);
  }
  setExpandedRows(newExpanded);
};


  // Fetch transfers
  // const fetchTransfers = async () => {
  //   try {
  //     setLoading(true);
  //     const res = await axios.get(
  //       'https://qacu7ie7ha.execute-api.ap-southeast-2.amazonaws.com/prod/api/transfers/list',
  //       {
  //         headers: {
  //           Region: getUserRegion(),
  //           organizationId: organizationId,
  //         },
  //       }
  //     );
  //     setTransfers(res.data);
  //   } catch (err) {
  //     showToast('Failed to fetch transfers', 'danger');
  //     console.error('Fetch error:', err);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
/****NEW crossregion */
// Replace ONLY this function
const fetchTransfers = async () => {
  try {
    setLoading(true);
    const res = await axios.get(
      "https://qacu7ie7ha.execute-api.ap-southeast-2.amazonaws.com/prod/api/transfers/list",
      {
        headers: {
          Region: getUserRegion(),      // sent as primary hint â€” backend scans all
          organizationId: organizationId,
        }
      }
    );
    // Backend already merged + deduped + all regions covered
    setTransfers(res.data);
  } catch (err) {
    showToast("Failed to fetch transfers", "danger");
    console.error("Fetch error", err);
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    if (organizationId) {
      fetchTransfers();
    }
  }, [organizationId]);

  const showToast = (message, variant = 'success') => {
    setToast({ show: true, message, variant });
    setTimeout(() => setToast({ show: false, message: '', variant: '' }), 3000);
  };

  // Check if destination country is restricted
  const isCountryRestricted = (country) => {
    return RESTRICTED_COUNTRIES.some(
      (restricted) => restricted.toLowerCase() === country.toLowerCase()
    );
  };

  // Auto-determine country status when destination changes
  useEffect(() => {
    if (form.destination) {
      const restricted = isCountryRestricted(form.destination);
      setForm((prev) => ({
        ...prev,
        countryStatus: restricted ? 'Restricted' : 'Allowed',
      }));
    }
  }, [form.destination]);

  const handleFileChange = (e) => {
    setForm({ ...form, tiaFile: e.target.files[0] });
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({
      ...form,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  // Validate form before submission
  const validateForm = () => {
    const errors = [];

    if (!form.type) errors.push('Transfer type is required');
    if (!form.source) errors.push('Source country is required');
    if (!form.destination) errors.push('Destination country is required');
    if (!form.entity) errors.push('Organization name is required');
    if (!form.status) errors.push('Status is required');
    if (!form.date) errors.push('Transfer date is required');
    if (!form.transferPurpose) errors.push('Transfer purpose is required');
    if (!form.recipientRole) errors.push('Recipient role is required');
    if (!form.legalBasis) errors.push('Legal basis is required');

    // DPDP-specific validations
    if (form.countryStatus === 'Restricted' && !form.govtNotificationReady) {
      errors.push('Government notification readiness must be confirmed for restricted countries');
    }

    if (form.legalBasis === 'Consent' && !form.consentObtained) {
      errors.push('Consent must be obtained when legal basis is consent');
    }

    if (form.legalBasis === 'Consent' && !form.consentReference) {
      errors.push('Consent reference/record ID is required');
    }

    if (!form.noticeProvided) {
      errors.push('Notice to data principal is mandatory under Section 6');
    }

    if (!form.noticeReference) {
      errors.push('Notice reference (privacy policy link) is required');
    }

    if (errors.length > 0) {
      showToast(errors.join('; '), 'danger');
      return false;
    }

    return true;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    const formData = new FormData();
    Object.entries(form).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        formData.append(key, value);
      }
    });

    formData.append("organizationId", organizationId || "");
    formData.append("region", getUserRegion());

    try {
      const headers = {
        Region: getUserRegion(),
        organizationId: organizationId || '',
        "Content-Type": "multipart/form-data",
      };

     // âœ… handleSubmit â€” UPDATE branch
if (editingTransfer) {
  await axios.put(
    `https://oh4g484cs3.execute-api.ap-southeast-2.amazonaws.com/prod/api/transfers/update/${editingTransfer.id}`,
    formData, { headers }
  );
  showToast('Transfer updated successfully');

  // 1ï¸âƒ£ Existing â€” keeps dashboard feed working
  await logActivity(`Updated data transfer to ${form.destination} (${form.recipientRole})`, 'warning');

  // 2ï¸âƒ£ New â€” feeds the unified Access Log tab
  logToAccessLogs?.({
    submodule:   'Cross-Border Transfers',
    action:      'Transfer Updated',
    severity:    'warning',
    description: `Updated data transfer to ${form.destination} (${form.recipientRole})`,
  });

} else {
  // âœ… handleSubmit â€” CREATE branch
  await axios.post(
    'https://vydp8czigb.execute-api.ap-southeast-2.amazonaws.com/prod/api/transfers/create',
    formData, { headers }
  );
  showToast('Transfer created successfully');

  // 1ï¸âƒ£ Existing
  await logActivity(`Created new data transfer to ${form.destination} (${form.recipientRole})`, 'success');

  // 2ï¸âƒ£ New
  logToAccessLogs?.({
    submodule:   'Cross-Border Transfers',
    action:      'Transfer Created',
    severity:    'success',
    description: `Created new data transfer to ${form.destination} (${form.recipientRole})`,
  });
}

      setShowModal(false);
      fetchTransfers();
      resetForm();
    } catch (err) {
      showToast("Failed to save transfer", "danger");
      console.error('Submit error:', err);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this transfer? This action cannot be undone.")) return;

    try {
      await axios.delete(
        `https://052xfaelsf.execute-api.ap-southeast-2.amazonaws.com/prod/api/transfers/delete/${id}`,
        {
          headers: {
            Region: getUserRegion(),
            organizationId: organizationId || '',
          },
        }
      );
      showToast("Transfer deleted successfully");
      const deletedTransfer = transfers.find((t) => t.id === id);
      await logActivity(
        `Deleted data transfer to ${deletedTransfer?.destination || 'unknown'} - ${deletedTransfer?.entity || ''}`,
        "danger"
      );
      logToAccessLogs?.({
  submodule:   'Cross-Border Transfers',
  action:      'Transfer Deleted',
  severity:    'danger',
  description: `Deleted data transfer to ${deletedTransfer?.destination || 'unknown'} â€” ${deletedTransfer?.entity}`,
});
      fetchTransfers();
    } catch (err) {
      showToast("Delete failed", "danger");
      console.error('Delete error:', err);
    }
  };

  const resetForm = () => {
    setForm({
      type: '',
      source: '',
      destination: '',
      entity: '',
      status: '',
      date: '',
      tiaFile: null,
      countryStatus: '',
      transferPurpose: '',
      recipientRole: '',
      noticeProvided: false,
      consentObtained: false,
      consentReference: '',
      noticeReference: '',
      govtNotificationReady: false,
      legalBasis: '',
      standardContractualClauses: false,
      onwardTransferRestrictions: '',
    });
  };

  const openNew = () => {
    setEditingTransfer(null);
    resetForm();
    setShowModal(true);
  };

  const openEdit = (transfer) => {
    setEditingTransfer(transfer);
    setForm({
      type: transfer.type || '',
      source: transfer.source || '',
      destination: transfer.destination || '',
      entity: transfer.entity || '',
      status: transfer.status || '',
      date: transfer.date || '',
      tiaFile: null,
      countryStatus: transfer.countryStatus || '',
      transferPurpose: transfer.transferPurpose || '',
      recipientRole: transfer.recipientRole || '',
      noticeProvided: transfer.noticeProvided || false,
      consentObtained: transfer.consentObtained || false,
      consentReference: transfer.consentReference || '',
      noticeReference: transfer.noticeReference || '',
      govtNotificationReady: transfer.govtNotificationReady || false,
      legalBasis: transfer.legalBasis || '',
      standardContractualClauses: transfer.standardContractualClauses || false,
      onwardTransferRestrictions: transfer.onwardTransferRestrictions || '',
    });
    setShowModal(true);
  };

  // Enhanced scoring algorithm with DPDP compliance factors
  useEffect(() => {
    if (!loading && onScoreUpdate) {
      let score = 0;

      if (transfers.length === 0) {
        score = 0;
      } else {
        const total = transfers.length;

        // 1. Active transfers (15 points)
        const activeTransfers = transfers.filter((t) => t.status === 'Active').length;
        const activeScore = (activeTransfers / total) * 15;

        // 2. TIA Document uploaded (15 points)
        const tiaUploadedCount = transfers.filter((t) => t.tiaFileKey).length;
        const tiaScore = (tiaUploadedCount / total) * 15;

        // 3. Valid source and destination (10 points)
        const validCountryCount = transfers.filter(
          (t) => t.source && t.destination && t.source.trim() !== '' && t.destination.trim() !== ''
        ).length;
        const countryScore = (validCountryCount / total) * 10;

        // 4. Valid dates (5 points)
        const validDateCount = transfers.filter(
          (t) => t.date && !isNaN(new Date(t.date).getTime())
        ).length;
        const dateScore = (validDateCount / total) * 5;

        // 5. DPDP Compliance - Transfer purpose specified (10 points)
        const purposeCount = transfers.filter(
          (t) => t.transferPurpose && t.transferPurpose.trim() !== ''
        ).length;
        const purposeScore = (purposeCount / total) * 10;

        // 6. DPDP Compliance - Recipient role specified (10 points)
        const roleCount = transfers.filter(
          (t) => t.recipientRole && t.recipientRole.trim() !== ''
        ).length;
        const roleScore = (roleCount / total) * 10;

        // 7. DPDP Compliance - Notice provided (10 points)
        const noticeCount = transfers.filter((t) => t.noticeProvided === true).length;
        const noticeScore = (noticeCount / total) * 10;

        // 8. DPDP Compliance - Consent obtained when required (10 points)
        const consentRequiredCount = transfers.filter((t) => t.legalBasis === 'Consent').length;
        const consentObtainedCount = transfers.filter(
          (t) => t.legalBasis === 'Consent' && t.consentObtained === true
        ).length;
        const consentScore = consentRequiredCount > 0 
          ? (consentObtainedCount / consentRequiredCount) * 10 
          : 10; // Full score if no consent-based transfers

        // 9. DPDP Compliance - Country status validated (10 points)
        const countryStatusCount = transfers.filter(
          (t) => t.countryStatus && ['Allowed', 'Restricted'].includes(t.countryStatus)
        ).length;
        const countryStatusScore = (countryStatusCount / total) * 10;

        // 10. DPDP Compliance - Legal basis specified (5 points)
        const legalBasisCount = transfers.filter(
          (t) => t.legalBasis && t.legalBasis.trim() !== ''
        ).length;
        const legalBasisScore = (legalBasisCount / total) * 5;

        score =
          activeScore +
          tiaScore +
          countryScore +
          dateScore +
          purposeScore +
          roleScore +
          noticeScore +
          consentScore +
          countryStatusScore +
          legalBasisScore;

        if (score > 100) score = 100;
      }
      onScoreUpdate(Math.round(score));
    }
  }, [transfers, loading, onScoreUpdate]);

  const logActivity = async (message, badge = "info") => {
    try {
      await axios.post(
       "https://ugat9qq1mj.execute-api.ap-southeast-2.amazonaws.com/prod/api/dpdp/activities/create",
       {
         message,
         badge,
         timestamp: new Date().toISOString()
       },
       {
         headers: {
           Region: getUserRegion(),
           organizationId: organizationId
         }
    });
   } catch (err) {
      console.warn("Failed to log activity:", err.message);
    }
  };

  return (
    <>
      <Row className="mb-3">
        <Col>
          <Alert variant="info" className="mb-0">
            <strong>DPDP Act Compliance:</strong> Cross-border transfers use a "negative list" approach. 
            Transfers are allowed to all countries except those restricted by Central Government notification. 
            Ensure notice, consent (when required), and contractual safeguards are in place .
          </Alert>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col className="text-end">
          <Button variant="primary" className="NewTransfer" size="sm" onClick={openNew}>
            <FaPlus className="me-1" />
            New Transfer
          </Button>
        </Col>
      </Row>

      <Card>
        <Card.Header>
          <h5>Cross-Border Data Transfer Register (DPDP Act 2023)</h5>
        </Card.Header>
        <Card.Body>
          {loading ? (
            <div className="text-center py-5">
              <Spinner animation="border" />
              <p className="cross-border-margin">Loading transfers...</p>
            </div>
          ) : transfers.length === 0 ? (
            <Alert variant="warning">
              No cross-border transfers recorded. Click "New Transfer" to add one.
            </Alert>
          ) : (
            <div className="table-responsive">
              <Table striped bordered hover>
                <thead className="table-dark">
                  <tr>
                    <th>ID</th>
                    <th>Type</th>
                    <th>Source â†’ Destination</th>
                    <th>Country Status</th>
                    <th>Organization</th>
                    <th>Recipient Role</th>
                    <th>Transfer Purpose</th>
                    <th>Legal Basis</th>
                    <th>Notice</th>
                    <th>Consent</th>
                    <th>Status</th>
                    <th>Date</th>
                    <th>TIA File</th>
                    <th>Actions</th>
                  </tr>
                </thead>
              <tbody>
  {transfers.map((t) => (
    <React.Fragment key={t.id}>
      {/* Main Row */}
      <tr>
        <td>
         <Button
  size="sm"
  variant="light"
  onClick={() => toggleRow(t.id)}
  className="p-0 arrow-dropdown no-btn-style"
>
  {expandedRows.has(t.id) ? 'â–¼' : 'â–¶'}
</Button>

          #{t.id?.substring(0, 8)}
        </td>

        <td>
          <Badge
            bg={
              t.type === 'Standard Contractual Safeguards'
                ? 'primary'
                : t.type === 'Group Data Protection Framework'
                ? 'info'
                : 'secondary'
            }
          >
            {t.type}
          </Badge>
        </td>
        <td>
          {t.source} â†’ {t.destination}
        </td>
        <td>
          {t.countryStatus === 'Restricted' ? (
            <Badge bg="danger">
              <FaExclamationTriangle className="me-1" />
              Restricted
            </Badge>
          ) : (
            <Badge bg="success">Allowed</Badge>
          )}
        </td>
        <td>{t.entity}</td>
        <td>
          <Badge
            bg={
              t.recipientRole === 'Processor'
                ? 'info'
                : t.recipientRole === 'Sub-processor'
                ? 'warning'
                : 'primary'
            }
          >
            {t.recipientRole}
          </Badge>
        </td>
        <td>{t.transferPurpose || '-'}</td>
        <td>
          <Badge bg={t.legalBasis === 'Consent' ? 'primary' : 'secondary'}>
            {t.legalBasis}
          </Badge>
        </td>
        <td>
          {t.noticeProvided ? (
            <Badge bg="success">âœ“</Badge>
          ) : (
            <Badge bg="danger">âœ—</Badge>
          )}
        </td>
        <td>
          {t.legalBasis === 'Consent' ? (
            t.consentObtained ? (
              <Badge bg="success">âœ“</Badge>
            ) : (
              <Badge bg="danger">âœ—</Badge>
            )
          ) : (
            <Badge bg="secondary">N/A</Badge>
          )}
        </td>
        <td>
          <Badge
            bg={
              t.status === 'Active'
                ? 'success'
                : t.status === 'Inactive'
                ? 'warning'
                : t.status === 'Revoked'
                ? 'danger'
                : 'secondary'
            }
          >
            {t.status}
          </Badge>
        </td>
        <td>{new Date(t.date).toLocaleDateString('en-IN')}</td>
        <td>
          {t.tiaFileKey ? (
            <a
              href={t.tiaFileKey}
              target="_blank"
              rel="noreferrer noopener"
            >
              View
            </a>
          ) : (
            '-'
          )}
        </td>
        <td>
          <Button
            size="sm"
            variant="outline-primary"
            className="me-1"
            onClick={() => openEdit(t)}
            title="Edit"
          >
            <FaEdit />
          </Button>
          <Button
            size="sm"
            variant="outline-danger"
            onClick={() => handleDelete(t.id)}
            title="Delete"
          >
            <FaTrash />
          </Button>
        </td>
      </tr>

      {/* Expandable Row - Shows Additional Details */}
      {expandedRows.has(t.id) && (
        <tr className="bg-light">
          <td colSpan={14}>
            <div className="p-3">
              <h6 className="text-primary mb-3">Additional Transfer Details</h6>
              
              <Row>
                {/* Standard Contractual Clauses */}
                <Col md={4} className="mb-3">
                  <strong className="d-block text-muted small">Standard Contractual Safeguards</strong>
                  {t.standardContractualClauses ? (
                    <Badge bg="success" className="mt-1">âœ“ Yes - SCSs in Place</Badge>
                  ) : (
                    <Badge bg="secondary" className="mt-1">âœ— No SCSs</Badge>
                  )}
                </Col>

                {/* Onward Transfer Restrictions */}
                <Col md={8} className="mb-3">
                  <strong className="d-block text-muted small">Onward Transfer Restrictions</strong>
                  <div className="mt-1">
                    {t.onwardTransferRestrictions ? (
                      <span>{t.onwardTransferRestrictions}</span>
                    ) : (
                      <span className="text-muted fst-italic">None specified</span>
                    )}
                  </div>
                </Col>
              </Row>

              {/* Government Notification (only for restricted countries) */}
              {t.countryStatus === 'Restricted' && (
                <Row>
                  <Col md={12} className="mb-3">
                    <Alert variant="warning" className="mb-0 py-2">
                      <strong className="d-block small">Government Notification Readiness</strong>
                      {t.govtNotificationReady ? (
                        <Badge bg="success" className="mt-1">âœ“ Confirmed - Ready for Restricted Transfer</Badge>
                      ) : (
                        <Badge bg="danger" className="mt-1">
                          <FaExclamationTriangle className="me-1" />
                          âœ— Not Confirmed
                        </Badge>
                      )}
                    </Alert>
                  </Col>
                </Row>
              )}

              <Row>
                {/* Notice Reference */}
                <Col md={6} className="mb-3">
                  <strong className="d-block text-muted small">Notice Reference / Privacy Policy</strong>
                  <div className="mt-1">
                    {t.noticeReference ? (
                      <a 
                        href={t.noticeReference} 
                        target="_blank" 
                        rel="noreferrer noopener"
                        className="text-primary"
                      >
                        View Privacy Policy â†’
                      </a>
                    ) : (
                      <span className="text-muted fst-italic">Not provided</span>
                    )}
                  </div>
                </Col>

                {/* Consent Reference */}
                <Col md={6} className="mb-3">
                  <strong className="d-block text-muted small">Consent Record Reference</strong>
                  <div className="mt-1">
                    {t.consentReference ? (
                      <code className="bg-white px-2 py-1 rounded">{t.consentReference}</code>
                    ) : (
                      <span className="text-muted fst-italic">
                        {t.legalBasis === 'Consent' ? 'Missing' : 'N/A (Not consent-based)'}
                      </span>
                    )}
                  </div>
                </Col>
              </Row>

              <Row>
                {/* Created At */}
                <Col md={4} className="mb-2">
                  <strong className="d-block text-muted small">Created At</strong>
                  <span className="small">
                    {t.createdAt ? new Date(t.createdAt).toLocaleString('en-IN') : '-'}
                  </span>
                </Col>

                {/* Updated At */}
                <Col md={4} className="mb-2">
                  <strong className="d-block text-muted small">Last Updated</strong>
                  <span className="small">
                    {t.updatedAt ? new Date(t.updatedAt).toLocaleString('en-IN') : '-'}
                  </span>
                </Col>

                {/* Transfer ID */}
                <Col md={4} className="mb-2">
                  <strong className="d-block text-muted small">Full Transfer ID</strong>
                  <code className="small">{t.id}</code>
                </Col>
              </Row>
            </div>
          </td>
        </tr>
      )}
    </React.Fragment>
  ))}
</tbody>

              </Table>
            </div>
          )}
        </Card.Body>
      </Card>

      {/* Enhanced Modal with DPDP fields */}
      <Modal show={showModal} onHide={() => setShowModal(false)} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>
            {editingTransfer ? 'Edit Cross-Border Transfer' : 'New Cross-Border Transfer'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            {/* Section 1: Basic Transfer Information */}
            <h6 className="text-primary mb-3">Basic Transfer Information</h6>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Transfer Type <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Select name="type" value={form.type} onChange={handleInputChange} required>
                    <option value="">Select...</option>
                    <option value="Standard Contractual Safeguards">
                      Standard Contractual Safeguards
                    </option>
                    <option value="Group Data Protection Framework">
                      Group Data Protection Framework
                    </option>
                    <option value="Permitted Jurisdiction">Permitted Jurisdiction</option>
                  </Form.Select>
                  <Form.Text className="text-muted">
                    Legal mechanism for the transfer 
                  </Form.Text>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Status <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Select name="status" value={form.status} onChange={handleInputChange} required>
                    <option value="">Select...</option>
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                    <option value="Revoked">Revoked</option>
                    <option value="Pending">Pending</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Source Country <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    name="source"
                    value={form.source}
                    onChange={handleInputChange}
                    placeholder="e.g., India"
                    required
                  />
                  <Form.Text className="text-muted">Country where data originates</Form.Text>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Destination Country <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    name="destination"
                    value={form.destination}
                    onChange={handleInputChange}
                    placeholder="e.g., United States"
                    required
                  />
                  <Form.Text className="text-muted">
                    Country receiving the data (checked against negative list)
                  </Form.Text>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Country Status <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    value={form.countryStatus}
                    readOnly
                    className={
                      form.countryStatus === 'Restricted'
                        ? 'bg-danger text-white'
                        : 'bg-success text-white'
                    }
                  />
                  <Form.Text className="text-muted">
                    Auto-determined based on government's negative list
                  </Form.Text>
                  {form.countryStatus === 'Restricted' && (
                    <Alert variant="danger" className="cross-border-margin">
                      <FaExclamationTriangle className="me-2" />
                      This country is on the restricted list. Government notification is required.
                    </Alert>
                  )}
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Transfer Date <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="date"
                    name="date"
                    value={form.date}
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            {/* Section 2: Recipient Information */}
            <hr className="my-4" />
            <h6 className="text-primary mb-3">Recipient Information</h6>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Organization Name <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    name="entity"
                    value={form.entity}
                    onChange={handleInputChange}
                    placeholder="Recipient organization name"
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Recipient Role <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Select
                    name="recipientRole"
                    value={form.recipientRole}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="">Select...</option>
                    <option value="Processor">Processor (Data Processor)</option>
                    <option value="Sub-processor">Sub-processor</option>
                    <option value="Controller">Controller (Data Fiduciary)</option>
                  </Form.Select>
                  <Form.Text className="text-muted">
                    Recipient's role under DPDP Act 
                  </Form.Text>
                </Form.Group>
              </Col>
            </Row>

            {/* Section 3: DPDP Compliance Requirements */}
            <hr className="my-4" />
            <h6 className="text-primary mb-3">DPDP Compliance Requirements</h6>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Transfer Purpose <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    name="transferPurpose"
                    value={form.transferPurpose}
                    onChange={handleInputChange}
                    placeholder="Describe the specific purpose of this data transfer..."
                    required
                  />
                  <Form.Text className="text-muted">
                    Purpose must be specific and lawful 
                  </Form.Text>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Legal Basis <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Select
                    name="legalBasis"
                    value={form.legalBasis}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="">Select...</option>
                    <option value="Consent">Consent (Section 6)</option>
                    <option value="Legitimate Use">
                      Legitimate Use (Section 7 - without consent)
                    </option>
                  </Form.Select>
                  <Form.Text className="text-muted">Lawful basis for processing </Form.Text>
                </Form.Group>
              </Col>
            </Row>

            {/* Notice and Consent Section */}
            <Row>
              <Col md={12}>
                <Alert variant="info">
                  <strong>Section 6 Requirement:</strong> Data fiduciaries must provide notice to data
                  principals before processing personal data, including cross-border transfers .
                </Alert>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Check
                    type="checkbox"
                    name="noticeProvided"
                    label="Notice provided to data principal"
                    checked={form.noticeProvided}
                    onChange={handleInputChange}
                    required
                  />
                  <Form.Text className="text-muted d-block cross-border-margin">
                    Clear and plain language notice describing data collection and purpose 
                  </Form.Text>
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Notice Reference / Privacy Policy Link <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="url"
                    name="noticeReference"
                    value={form.noticeReference}
                    onChange={handleInputChange}
                    placeholder="https://example.com/privacy-policy"
                    required
                  />
                  <Form.Text className="text-muted">
                    Link to privacy notice or policy document
                  </Form.Text>
                </Form.Group>
              </Col>

              <Col md={6}>
                {form.legalBasis === 'Consent' && (
                  <>
                    <Form.Group className="mb-3">
                      <Form.Check
                        type="checkbox"
                        name="consentObtained"
                        label="Explicit consent obtained for cross-border transfer"
                        checked={form.consentObtained}
                        onChange={handleInputChange}
                        required={form.legalBasis === 'Consent'}
                      />
                      <Form.Text className="text-muted d-block cross-border-margin">
                        Consent must be free, specific, informed, unconditional, and unambiguous
                        
                      </Form.Text>
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Consent Record Reference <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        name="consentReference"
                        value={form.consentReference}
                        onChange={handleInputChange}
                        placeholder="Consent record ID or reference"
                        required={form.legalBasis === 'Consent'}
                      />
                      <Form.Text className="text-muted">
                        Reference to consent management system record
                      </Form.Text>
                    </Form.Group>
                  </>
                )}
              </Col>
            </Row>

            {/* Contractual Safeguards */}
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Check
                    type="checkbox"
                    name="standardContractualClauses"
                    label="Standard Contractual Safeguards (SCSs) in place"
                    checked={form.standardContractualClauses}
                    onChange={handleInputChange}
                  />
                  <Form.Text className="text-muted d-block cross-border-margin">
                    Contractual safeguards ensuring data protection compliance 
                  </Form.Text>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Onward Transfer Restrictions</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={2}
                    name="onwardTransferRestrictions"
                    value={form.onwardTransferRestrictions}
                    onChange={handleInputChange}
                    placeholder="Describe any restrictions on onward transfers by the recipient..."
                  />
                </Form.Group>
              </Col>
            </Row>

            {/* Government Notification Readiness */}
            {form.countryStatus === 'Restricted' && (
              <Row>
                <Col md={12}>
                  <Alert variant="danger">
                    <Form.Group className="mb-0">
                      <Form.Check
                        type="checkbox"
                        name="govtNotificationReady"
                        label="Confirm government notification requirements are met for restricted country transfer"
                        checked={form.govtNotificationReady}
                        onChange={handleInputChange}
                        required
                      />
                      <Form.Text className="text-white d-block cross-border-margin">
                        <FaExclamationTriangle className="me-1" />
                        Transfers to restricted countries require compliance with government
                        notifications under Section 16 
                      </Form.Text>
                    </Form.Group>
                  </Alert>
                </Col>
              </Row>
            )}

            {/* Section 4: Documentation */}
            <hr className="my-4" />
            <h6 className="text-primary mb-3">Transfer Impact Assessment (TIA) Documentation</h6>
            <Row>
              <Col md={12}>
                <Form.Group className="mb-3">
                  <Form.Label>TIA Document (PDF)</Form.Label>
                  <Form.Control type="file" accept="application/pdf" onChange={handleFileChange} />
                  <Form.Text className="text-muted">
                    Upload Transfer Impact Assessment or relevant legal documentation
                  </Form.Text>
                  {editingTransfer?.tiaFileKey && (
                    <div className="cross-border-margin">
                      <Badge bg="info">
                        Current file:{' '}
                        <a
                          href={editingTransfer.tiaFileKey}
                          target="_blank"
                          rel="noreferrer noopener"
                          className="text-white"
                        >
                          View existing document
                        </a>
                      </Badge>
                    </div>
                  )}
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSubmit}>
            {editingTransfer ? 'Update Transfer' : 'Create Transfer'}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Toast Notifications */}
      <ToastContainer position="bottom-end" className="p-3">
        <Toast show={toast.show} bg={toast.variant} onClose={() => setToast({ ...toast, show: false })}>
          <Toast.Body className="text-white">{toast.message}</Toast.Body>
        </Toast>
      </ToastContainer>
    </>
  );
};

export default CrossBorderTransfersTab;